import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const ChevronIcon = ({ open }) => (
  <svg
    className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const isGroupActive = (item, pathname) =>
  item.children?.some(
    (child) => pathname === child.href || pathname.startsWith(`${child.href}/`)
  );

const SidebarNavItems = ({ items, isMobile = false, onNavigate }) => {
  const { pathname } = useLocation();
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    const nextOpen = {};
    items.forEach((item) => {
      if (item.children && isGroupActive(item, pathname)) {
        nextOpen[item.name] = true;
      }
    });
    setOpenGroups(nextOpen);
  }, [pathname, items]);

  const collapseGroups = () => setOpenGroups({});

  const toggleGroup = (name) => {
    setOpenGroups((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const linkClass = (isActive) =>
    isMobile
      ? "group flex items-center px-4 py-2 text-base font-medium rounded-md text-white hover:bg-gray-50 hover:text-gray-900"
      : `group flex items-center px-4 py-2 text-lg font-medium rounded-md ${
          isActive
            ? "bg-white text-black"
            : "text-white hover:bg-white hover:text-black"
        }`;

  const childLinkClass = (isActive) =>
    isMobile
      ? "block px-4 py-2 text-sm font-medium rounded-md text-white hover:bg-gray-50 hover:text-gray-900"
      : `block px-4 py-2 text-base font-medium rounded-md ${
          isActive
            ? "bg-white text-black"
            : "text-white hover:bg-white hover:text-black"
        }`;

  return (
    <>
      {items.map((item) => {
        if (item.children?.length) {
          const groupOpen = !!openGroups[item.name];
          const groupActive = isGroupActive(item, pathname);

          return (
            <div key={item.name} className={isMobile ? "" : "mt-4"}>
              <button
                type="button"
                onClick={() => toggleGroup(item.name)}
                className={`${linkClass(groupActive)} w-full justify-between mt-0`}
              >
                <span className="flex items-center">
                  {item.icon}
                  <span className="px-2">{item.name}</span>
                </span>
                <ChevronIcon open={groupOpen} />
              </button>

              {groupOpen && (
                <div className={`${isMobile ? "ml-4 mt-1" : "ml-8 mt-1"} space-y-1`}>
                  {item.children.map((child) =>
                    isMobile ? (
                      <a
                        key={child.name}
                        href={child.href}
                        className={childLinkClass(pathname === child.href)}
                        onClick={onNavigate}
                      >
                        {child.name}
                      </a>
                    ) : (
                      <NavLink
                        key={child.name}
                        to={child.href}
                        className={({ isActive }) => childLinkClass(isActive)}
                      >
                        {child.name}
                      </NavLink>
                    )
                  )}
                </div>
              )}
            </div>
          );
        }

        return isMobile ? (
          <a
            key={item.name}
            href={item.href}
            className={linkClass(false)}
            onClick={() => {
              collapseGroups();
              onNavigate?.();
            }}
          >
            {item.name}
          </a>
        ) : (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={collapseGroups}
            className={({ isActive }) => `${linkClass(isActive)} mt-4`}
          >
            {item.icon}
            <span className="px-2">{item.name}</span>
          </NavLink>
        );
      })}
    </>
  );
};

export default SidebarNavItems;
